// extracted by mini-css-extract-plugin
export var active = "_8l-d";
export var blink = "_8l-e";
export var container = "_8l-5";
export var controls = "_8l-0";
export var controlsRight = "_8l-1";
export var fakeCursor = "_8l-c";
export var hidden = "_8l-b";
export var quillContainerSmall = "_8l-7";
export var quillEditor = "_8l-6";
export var quillEditorSmall = "_8l-8";
export var quillFormatButtons = "_8l-a";
export var quillToolbar = "_8l-9";
export var removePadding = "_8l-2";
export var state = "_8l-3";
export var stateTitle = "_8l-4";